<div *ngIf="isLoading" class="loading-overlay">
    <div class="loading-spinner">
        <uitk-loading-indicator uitkId="reportsLoading" [visibleText]="'Loading...'" spinnerSize="large">
        </uitk-loading-indicator>
    </div>
</div>

<div class="container-fluid mt-4 px-4">
  <div class="row" style="margin-top: 20px;">
    <div class="col">
      <h2 style="color: #002677;"><b>Reports</b></h2>
    </div>
  </div>
  <div *ngIf="modeService.isWaiting" class="row mt-5">
    <div class="col d-flex justify-content-center">
      <img src="assets/images/spin.gif" width="200" height="200" alt="" />
    </div>
  </div>
  <div class="row" *ngIf="!modeService.isWaiting">
    <div class="container-fluid mt-4 px-4">
      <nav style="margin-top: -18px;">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <button *ngIf="salesReports?.length > 0" class="nav-link active" id="nav-sales-tab" data-bs-toggle="tab" data-bs-target="#nav-sales"
            type="button" role="tab" aria-controls="nav-sales" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'salesTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel1' ?'bold':'normal'}"
            (click)="selectPanel('salesTab')" [class.active]="selectedPanel === 'salesTab'">Sales</button>
          <button *ngIf="productReports?.length > 0" class="nav-link" id="nav-product-tab" data-bs-toggle="tab" data-bs-target="#nav-product" type="button"
            role="tab" aria-controls="nav-product" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'productTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel2' ?'bold':'normal'}"
            (click)="selectPanel('productTab')" [class.active]="selectedPanel === 'productTab'">Product/Inventory</button>
          <button *ngIf="revenueReports?.length > 0" class="nav-link" id="nav-revenue-tab" data-bs-toggle="tab" data-bs-target="#nav-revenue" type="button"
            role="tab" aria-controls="nav-revenue" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'revenueTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel3' ?'bold':'normal'}"
            (click)="selectPanel('revenueTab')" [class.active]="selectedPanel === 'revenueTab'">Revenue </button>
          <button *ngIf="marketingReports?.length > 0" class="nav-link" id="nav-marketing-tab" data-bs-toggle="tab" data-bs-target="#nav-marketing"
            type="button" role="tab" aria-controls="nav-marketing" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'marketingTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel4' ?'bold':'normal'}"
            (click)="selectPanel('marketingTab')" [class.active]="selectedPanel === 'marketingTab'">Marketing</button>
          <button *ngIf="financeReports?.length > 0" class="nav-link" id="nav-finance-tab" data-bs-toggle="tab" data-bs-target="#nav-finance" type="button"
            role="tab" aria-controls="nav-finance" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'financeTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel5' ?'bold':'normal'}"
            (click)="selectPanel('financeTab')" [class.active]="selectedPanel === 'financeTab'">Finance</button>
          <button *ngIf="newAcctsRecvReports?.length > 0" class="nav-link" id="nav-peopleSoft-tab" data-bs-toggle="tab" data-bs-target="#nav-peopleSoft" type="button"
            role="tab" aria-controls="nav-peopleSoft" aria-selected="false"
            style="border-left: none; border-top: none;border-right: none; border-width: 3px; font-family: Microsoft Sans Serif; letter-spacing: 0.12px;"
            [ngStyle]="{'border-color':selectedPanel === 'peopleSoftTab' ?'#002677':'transparent', 'font-weight':selectedPanel === 'panel5' ?'bold':'normal'}"
            (click)="selectPanel('peopleSoftTab')" [class.active]="selectedPanel === 'peopleSoftTab'">NewAcctsRecv</button>
        </div>
      </nav>
      <div class="tab-content">
        <!-------------------------------------------------------------------- Sales -------------------------------------------------------------------->
        <div class="tab-pane fade show" [ngClass]="selectedPanel === 'salesTab' ? 'active' : ''" id="nav-sales"
          role="tabpanel" aria-labelledby="nav--tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;"
              *ngFor="let report of salesReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                    class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>

          </div>
          <hr class="hr-width">
        </div>
        <!-------------------------------------------------------------------- Product   -------------------------------------------------------------------->
        <div class="tab-pane fade show" [ngClass]="selectedPanel === 'productTab' ? 'active' : ''" id="nav-product"
          role="tabpanel" aria-labelledby="nav-product-tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;" *ngFor="let report of productReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
                <div class="col d-flex justify-content-end">

                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                    class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-width">
        </div>
        <!-------------------------------------------------------------------- Revenue Dashbord -------------------------------------------------------------------->
        <div class="tab-pane fade show" [ngClass]="selectedPanel === 'revenueTab' ? 'active' : ''" id="nav-revenue"
          role="tabpanel" aria-labelledby="nav-revenue-tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;"
              *ngFor="let report of revenueReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
                <div class="col d-flex justify-content-end">

                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                    class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-width">
        </div>
        <!-------------------------------------------------------------------- Marketing -------------------------------------------------------------------->
        <div class="tab-pane show fade show" [ngClass]="selectedPanel === 'marketingTab' ? 'active' : ''" id="nav-marketing"
          role="tabpanel" aria-labelledby="nav-marketing-tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;" *ngFor="let report of marketingReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
                <div class="col d-flex justify-content-end">

                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                  class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-width">
          
        </div>
        <!-------------------------------------------------------------------- Finance -------------------------------------------------------------------->
        <div class="tab-pane show fade show" [ngClass]="selectedPanel === 'financeTab' ? 'active' : ''" id="nav-finance"
          role="tabpanel" aria-labelledby="nav-finance-tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;"
              *ngFor="let report of financeReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
                <div class="col d-flex justify-content-end">
                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                    class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-width">
        </div>

         <!-------------------------------------------------------------------- PeopleSoft -------------------------------------------------------------------->
        <div class="tab-pane show fade show" [ngClass]="selectedPanel === 'peopleSoftTab' ? 'active' : ''" id="nav-peopleSoft"
          role="tabpanel" aria-labelledby="nav-peopleSoft-tab">
          <div class="col-12 row mt-3 g-3">
            <div class="card h-200 col-2" style="margin-left: 10px; margin-right: 10px;"
              *ngFor="let report of newAcctsRecvReports">
              <div class="row mt-2 mx-2">
                <div class="col-12">
                  <h5 class="card-title"><b>{{report.reportName.replace('External', '')}}

                    </b></h5>
                </div>
                <div class="col d-flex justify-content-end">
                </div>
              </div>
              <div class="row mt-3 h-100">
                <div class="col d-flex justify-content-center align-items-end">
                  <button id="card-btn" type="button" (click)="selectReport(report)"
                    class="uitk-c-button uitk-c-button--default uitk-u-margin-right--base uitk-u-margin-bottom--xs width-150">Open</button>
                </div>
              </div>
            </div>
          </div>
          <hr class="hr-width">
        </div>
      </div>
      <div id="reportContainer" [hidden]="selectedPanel !== activeReportTab || isRealTimeReport" style="height: 80vh; width: 100%; margin-top: 20px;"></div>
      <div [hidden]="selectedPanel !== activeReportTab || !isRealTimeReport">
        <form id="embedFormRealTime" [attr.action]="orbitUrl" method="POST" target="reportIframeRealTime">
          <input type="hidden" name="workspaceID" [value]="selectedWorkspaceID" />
          <input type="hidden" name="reportID" [value]="selectedReportID" />
          <input type="hidden" name="token" [value]="encryptedTokenString" />
        </form>
        <iframe name="reportIframeRealTime" style="height: 80vh; width: 100%; margin-top: 20px;" title="Real Time Stats Report"></iframe>
      </div>
    </div>
  </div>
</div>